import script from "./AppIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AppIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
